import { HTMLAttributes } from "react";

export default function Vercel(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="256"
      height="256"
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="256" height="256" rx="128" fill="black" />
      <path d="M128 52.9189L204 184.556H52L128 52.9189Z" fill="white" />
    </svg>
  )
}
